export default __webpack_public_path__ + "77f2354d6c89a9e206faca27e2bff4db.svg";